<template>
    <el-popover style="left: 0;" ref="productPopover" placement="bottom" trigger="hover" popper-class="custom-product-popover">
        <div class="product-container">
        <!-- 飞行平台 -->
        <div class="product-category">
            <h3 class="category-title">飞行平台</h3>
            <div class="product-list">
                <div class="product-item" v-for="(item, index) in flightPlatform" :key="index"
                    @click="handleProductClick(item, 'flightPlatform')">
                    <div class="product-image">
                        <img v-lazy="item.image" :alt="item.name" />
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ item.code }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 智能控制系统 -->
        <div class="product-category">
            <h3 class="category-title">智能控制系统</h3>
            <div class="product-list">
                <div class="product-item" v-for="(item, index) in controlSystem" :key="index"
                    @click="handleProductClick(item, 'controlSystem')">
                    <div class="product-image">
                        <img v-lazy="item.image" :alt="item.name" />
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ item.code }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 毫米波雷达 -->
        <div class="product-category">
            <h3 class="category-title">毫米波雷达</h3>
            <div class="product-list">
                <div class="product-item" v-for="(item, index) in radar" :key="index"
                    @click="handleProductClick(item, 'radar')">
                    <div class="product-image">
                        <img v-lazy="item.image1" :alt="item.name" />
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ item.code }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 控制平台及软件 -->
        <div class="product-category">
            <h3 class="category-title">控制平台及软件</h3>
            <div class="product-list">
                <div class="product-item" v-for="(item, index) in platformSoftware" :key="index"
                    @click="handleProductClick(item, 'platformSoftware')">
                    <div class="product-image">
                        <img v-lazy="item.image" :alt="item.name" />
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ item.name }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 其他智能设备 -->
        <!-- <div class="product-category">
            <h3 class="category-title">其他智能设备</h3>
            <div class="product-list">
                <div class="product-item" v-for="(item, index) in otherDevices" :key="index"
                    @click="handleProductClick(item, 'otherDevices')">
                    <div class="product-image">
                        <img :src="item.image" :alt="item.name" />
                    </div>
                    <div class="product-info">
                        <div class="product-name">{{ item.name }}</div>
                        <div class="product-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div> -->
        </div>
        <template slot="reference">
            <slot name="trigger"></slot>
        </template>
    </el-popover>
</template>

<script>
import productDataMixin from '../mixins/productData.js'

export default {
    name: 'Product',
    mixins: [productDataMixin],
    methods: {
        handleProductClick(item, category) {
            // 触发自定义事件，传递产品信息给父组件
            this.$emit('product-click', {
                item: item,
                category: category
            });
            
            // 关闭 popover
            if (this.$refs.productPopover) {
                this.$refs.productPopover.doClose();
            }
            
            if(category === 'flightPlatform'){
                const targetRoute = `/x15?code=${item.code}`;
                const currentRoute = this.$route.fullPath;
                
                // 只有当目标路由与当前路由不同时才跳转，避免冗余导航错误
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        // 忽略 NavigationDuplicated 错误（Vue Router 3.x）
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
            }else if(category === 'controlSystem'){
                const targetRoute = `/smartDevice?code=${item.code}`;
                const currentRoute = this.$route.fullPath;
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
            }else if(category === 'platformSoftware'){
                if(item.code === 'AI'){
                    return false;
                }
                const targetRoute = `/UAVControlPlatform?code=${item.code}`;
                const currentRoute = this.$route.fullPath;
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
            }else if(category === 'radar'){
                const targetRoute = `/Radar?code=${item.code}`;
                const currentRoute = this.$route.fullPath;
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    })
                }
            }
        }
    }
}
</script>

<style scoped>
.product-container {
    width: 1905px;
    left: 20px;
    padding: 40px 150px;
    background: #ffffff;
    display: flex;
    gap: 30px;
    justify-content: space-between;
    box-sizing: border-box;
}

.product-category {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.category-title {
    font-family: Microsoft YaHei;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
    margin: 0 0 20px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #e0e0e0;
}

.product-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.product-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.product-item:hover {
    background-color: #f5f7fa;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.product-image {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    overflow: hidden;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.product-item:hover .product-image img {
    transform: scale(1.1);
}

.product-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    height: 100%;
}

.product-name {
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    line-height: 1.4;
    /* 不换行 */
    white-space: nowrap;
    transition: color 0.3s ease;
}

.product-item:hover .product-name {
    color: #1C9AF3;
}

.product-desc {
    font-family: Microsoft YaHei;
    font-size: 12px;
    color: #666666;
    line-height: 1.5;
    white-space: nowrap;

}
</style>
<style>
/* 全局样式 - 专门用于 el-popover */
.custom-product-popover {

    left: 0 !important; /* 设置弹出框的 left 位置 */
    transform: translateX(0) !important; /* 确保重置默认的 transform */
}

/* 隐藏箭头 */
.custom-product-popover .popper__arrow {
    display: none !important;
}

/* 滚动条样式 */
.custom-product-popover::-webkit-scrollbar {
    width: 6px;
}

.custom-product-popover::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.custom-product-popover::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.custom-product-popover::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
</style>
